/**
 * 后台请求基础路径
 */
let baseUrl={
	/*//rac 基础路径
	rac:generalConfig.racBase,
	//文档中心基础路径
	doc:generalConfig.docBase,
	//认证基础路径
	auth:generalConfig.authBase,
	//用户管理基础路径
	user:generalConfig.userBase,
	portal:generalConfig.portalBase,
	sincerity:generalConfig.sincerityBase,*/

	// 科创平台
	platform:"/uoc/platform-declare-api",
	platformNotAuth:"/platform-declare-api",
	pcs:'/pcs',
	umc:'/uoc/umc',
	umcNotAuth:'/umc',
	// 新接口基础地址
	apiBase: 'https://www.ylnkzh.cn',
	apiBaseUmc: 'https://www.ylnkzh.cn/umc',
	apiBaseAuth: 'https://www.ylnkzh.cn/uoc',
	// 字典服务
	dict: 'https://www.ylnkzh.cn/umc',
	// 文件服务
	oss: 'https://www.ylnkzh.cn/oss',
	// 成果超市API
	achievement: 'https://www.ylnkzh.cn/uoc/achievement-api',
	// 需求大厅API
	requirement: 'https://www.ylnkzh.cn/uoc/requirement-api',
	// 专家人才API
	expert: 'https://www.ylnkzh.cn/uoc',
	// 技术经理人API
	tecManager: 'https://www.ylnkzh.cn/uoc/tecmanager-api',
	// 企业API
	enterprise: 'https://www.ylnkzh.cn/pcs',
	// 交易中心API
	matcher: 'https://www.ylnkzh.cn/uoc/matcher-api',
		// 交易中心API
	matcherAuth: 'https://www.ylnkzh.cn/uoc/matcher-api',
	// 科研仪器API
	instrument: 'https://www.ylnkzh.cn/uoc/instrument-api',
	// 对接咨询API
	ask: 'https://www.ylnkzh.cn/uoc/matcher-api/member/match/ask',
	// 价值评估API
	valueAssess: 'https://www.ylnkzh.cn/uoc/achievement-api'
}
export default baseUrl
